import { navigate } from 'gatsby';
import React, { useEffect, useState, useRef }from "react";
import { toast } from "react-toastify";
import {getCategories,getBrands} from "../../service/myProductService";
import { useLocation } from '@reach/router';
import loadScript from '../Layout/loadScript';
const Menu = (props) =>{
    const loadMapScript=()=> {
        loadScript('/static/css/style.js?onload=index')
          .then((script) => {
            // this.mapScript = script;
            // this.setState({ apiLoaded: true });
          })
          .catch((err) => {
            console.error(err.message);
          });
      }
    const location = useLocation();
    let uri = location.pathname?.replace('.html','').replace('/','');
    const textSearchRef = useRef('');
    const handleSearch=()=>{
        let _keywword = textSearchRef.current.value;
        if(_keywword === ''){
            toast.warning('Bạn chưa nhập thông tin tìm kiếm.');
        }else{
            navigate('/ket-qua-tim-kiem.html?'+_keywword);
        }
      }
      const handleKeyPressSearch = (e) => {
        if (e.key === 'Enter') {
            let _keywword = textSearchRef.current.value;
            if(_keywword === ''){
                toast.warning('Bạn chưa nhập thông tin tìm kiếm.');
            }else{
                navigate('/ket-qua-tim-kiem.html?'+_keywword);
            }
        }
      }
      const [items, setItem]= useState([]);
      const getDataCategories=()=>{
        getCategories().then((response)=>{
            if(+response.status === 200){
                setItem(response.message);
                window.localStorage.setItem('itemCate', JSON.stringify(response.message));
                window.localStorage.setItem('cateNode', true);
                var _uri_cate = [];
                response.message?.forEach(element => {
                    _uri_cate.push(element.url_key);
                    if(element.child?.length > 0){
                        element.child?.forEach(element1 => {
                            _uri_cate.push(element1.url_key);
                            if(element1.child.length > 0){
                                element1.child?.forEach(element2 => {
                                    _uri_cate.push(element2.url_key);
                                });
                            }
                        });
                    }
                });
                // window.localStorage.setItem('itemCateName', JSON.stringify(_uri_cate));
            }
        });
      }
    //   const loadDataBrand=()=>{
    //     getBrands().then((response)=>{
    //         if(+response.status === 200){
    //             var _uri_brand = [];
    //             response.message?.forEach(element => {
    //                 _uri_brand.push(element.url_key);
    //             });
    //             // window.localStorage.setItem('itemUriBrand', JSON.stringify(_uri_brand));
    //         }
    //     });
    //   }

      useEffect(()=>{
        getDataCategories("","","");
        // loadDataBrand();
        setTimeout(function() {
            loadMapScript();
        }, 100);
       
      },[uri]);
      const handleRedirect=(uri,name)=>{
        let _uri = "/"+uri+".html";
        window.localStorage.setItem('typepage', 'category');
        window.localStorage.setItem('nameCategory', name);
        navigate(_uri);
      }
      const handleShowmenu=()=>{
        // getDataCategories("","","");
      }
    return  (
        <>
            <div id="so-groups" className="left-menu so-groups-sticky hidden-xs" style={{top: 196}}>
            <div className="a-href sticky-categories menu-home" data-target="popup" data-popup="#popup-categories" onClick={()=>handleShowmenu()}>
                    <span>Danh mục sản phẩm</span><i className="fa fa-align-justify"></i>
                </div>
                <a href='/cart.html' className="sticky-mycart menu-home" data-target="popup"><span>Giỏ hàng</span><i className="fa fa-shopping-cart"></i></a>
                <div className="a-href sticky-mysearch menu-home" data-target="popup" data-popup="#popup-mysearch">
                    <span>Tìm kiếm</span><i className="fa fa-search"></i>
                </div>
                <a className="sticky-recent menu-home" href="tel:+18006886"><span>Call Me (18006886)</span><i className="fa fa-phone"></i></a>
                
                <div className="popup popup-categories popup-hidden" id="popup-categories">
                    <div className="popup-screen">
                        <div className="popup-position">
                            <div className="popup-container popup-small">
                                <div className="popup-header">
                                    <span><i className="fa fa-align-justify"></i>Danh mục</span>
                                    <a href='/san-pham.html' className="popup-close" data-target="popup-close" data-popup-close="#popup-categories">&times;</a>
                                </div>
                                <div className="popup-content">
                                    <div className="nav-secondary">
                                        <ul>
                                            {
                                                items.length > 0 ? (
                                                    items.map((item,i)=>{
                                                        return <li key={i}>
                                                            {
                                                                item.child?.length > 0 ?(
                                                                    <span className="nav-action">
                                                                        <i className="fa fa-plus more"></i>
                                                                        <i className="fa fa-minus less"></i>
                                                                    </span>
                                                                ):(null)
                                                            }
                                                            <a href={"/"+item.url_key+".html"}><i className="fa fa-chevron-down nav-arrow"></i> {item.name}</a>
                                                            {
                                                                item.child?.length > 0 ?(
                                                                <ul className="level-2">
                                                                    {
                                                                        item.child?.map((childNode,j)=>{
                                                                            return  <li key={j}>
                                                                            {
                                                                                childNode.child.length > 0 ?(
                                                                                    <span className="nav-action">
                                                                                        <i className="fa fa-plus more"></i>
                                                                                        <i className="fa fa-minus less"></i>
                                                                                    </span>
                                                                                ):(null)
                                                                            }
                                                                            <a href={"/"+childNode.url_key+".html"}><i className="fa fa-chevron-down nav-arrow"></i> {childNode.name}</a>
                                                                                
                                                                                {
                                                                                    childNode.child?.length > 0 ?(
                                                                                    <ul className="level-3">
                                                                                        {
                                                                                            childNode.child?.map((childNode1,k)=>{
                                                                                            return  <li key={k}>
                                                                                                <a href={"/"+childNode1.url_key+".html"}><i className="fa fa-chevron-down nav-arrow"></i> {childNode1.name}</a>
                                                                                                </li>
                                                                                            })
                                                                                        }
                                                                                    </ul>
                                                                                    ):(null)
                                                                                }
                                                                            </li>
                                                                        })
                                                                    }
                                                                </ul>
                                                                ):(null)
                                                            }
                                                        </li>
                                                    })
                                                ): (null)
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="popup popup-mycart popup-hidden" id="popup-mycart">
                    <div className="popup-screen">
                        <div className="popup-position">
                            <div className="popup-container popup-small">
                                <div className="popup-html">
                                    <div className="popup-header">
                                        <span><i className="fa fa-shopping-cart"></i>Shopping Cart</span>
                                        <a href='#'  className="popup-close" data-target="popup-close" data-popup-close="#popup-mycart">&times;</a>
                                    </div>
                                    <div className="popup-content">
                                        <div className="cart-header">
                                            <div className="notification gray">
                                                <i className="fa fa-shopping-cart info-icon"></i>
                                                <p>Your shopping cart is empty!</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="popup popup-mysearch popup-hidden" id="popup-mysearch">
                    <div className="popup-screen">
                        <div className="popup-position">
                            <div className="popup-container popup-small">
                                <div className="popup-html">
                                    <div className="popup-header">
                                        <span><i className="fa fa-search"></i>Tìm kiếm</span>
                                        <a href='#'  className="popup-close" data-target="popup-close" data-popup-close="#popup-mysearch">&times;</a>
                                    </div>
                                    <div className="popup-content">
                                        <div className="form-content">
                                            <div className="row space">
                                                <div className="col">
                                                    <div className="form-box">
                                                        <input type="text" id="" 
                                                        className="field" placeholder="Nhập thông tin tìm kiếm" ref={textSearchRef} onKeyDown={handleKeyPressSearch}/>
                                                        <i className="fa fa-search sbmsearch"></i>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="form-box">
                                                        <button type="button" id="" className="btn button-search" onClick={()=>handleSearch()}>Tìm kiếm</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </>
        
        )
}

export default Menu